<template>
  <div class="m-title">
    <span>{{titleText}}</span>
    <el-tooltip class="item" effect="light" :content="tipText" placement="top">
      <i class="el-icon-question" v-if="tipText"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "mTitle",
  props: {
    titleText:{
      type:String,
      default:''
    },
    tipText:{
      type:String,
      default:''
    }
  }
}
</script>

<style scoped lang="scss">
  .m-title {
    position: absolute;
    left: calc(0.3 * var(--fontSize));
    top: calc(0.23 * var(--fontSize));
    font-size: calc(0.18 * var(--fontSize));
    display: flex;
    align-items: center;
    z-index: 2;
    pointer-events: auto;
    .el-icon-question {
      color: rgba(253, 183, 33, 0.84);
      cursor: pointer;
      font-size: calc(0.18 * var(--fontSize));
      margin-left: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mTitle.vue